module.exports = __webpack_public_path__ + "static/media/Design2.8e52a40c.svg";